import { CoreContext } from 'context/CoreContext';
import { useContext } from 'react';
import { ThemedComponent } from 'ui/theme';
import ModalAddProposal from '../AddProposal';
import AgendaProposta from '../AgendaProposta';
import BankingCobranca from '../BankingCobranca';
import BankingCredito from '../BankingCredito';
import ModalCreditoErro from '../BankingCreditoErro';
import BankingDocumentos from '../BankingDocumentos';
import BankingMotor from '../BankingMotor';
import BankingNegocios from '../BankingNegocios';
import BankingProfissaoOmni from '../BankingProfissaoOmni';
import BankingRenegociar from '../BankingRenegociacao';
import BillingCancelRenegotiation from '../BillingCancelRenegotiation';
import BillingForward from '../BillingForward';
import BillingRunDunning from '../BillingRunDunning';
import ConfirmDate from '../ConfirmDate';
import ConfirmDocumentation from '../ConfirmDocumentation';
import CuradoriaBanking from '../CuradoriaBanking';
import CuradoriaCredito from '../CuradoriaBankingCredito';
import FinalizaSol from '../FinalizaSol';
import FormalizaBanco from '../FormalizaBanco';
import HistoricoCobranca from '../HistoricoCobranca';
import ImportarCobranca from '../ImportarCobranca';
import ModalLog from '../LogImport';
import MotivoRecusa from '../ModalMotivosRecusa';
import ModalUploadFile from '../ModalUploadFile';
import ModalObservacao from '../Observacao';
import ModalSample from '../Sample';

export default function ModalCore() {
  const { modal } = useContext(CoreContext);

  return (
    <>
      <ThemedComponent>
        {modal?.type === 'sample' ? (
          <ModalSample
            banco={modal?.banco}
            id={modal?.id}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'confirm_date' ? <ConfirmDate {...modal} /> : null}
        {modal?.type === 'add-proposal' ? (
          <ModalAddProposal banco={modal?.banco} id={modal?.id} />
        ) : null}
        {modal?.type === 'bureau' ? (
          <BankingMotor
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'credito' ? (
          <BankingNegocios
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'bankmesa' ? (
          <BankingDocumentos
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'parecer' ? (
          <BankingCredito
            dados={modal?.dados}
            reload={modal?.reload}
            reloadWindow={modal?.reloadWindow}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'curadoriabanking' ? (
          <CuradoriaBanking
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'log' ? (
          <ModalLog
            itensErros={modal?.adicionais}
            itensCorretos={modal?.certos}
          />
        ) : null}
        {modal?.type === 'agendarcliente' ? (
          <AgendaProposta dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'renegociar' ? (
          <BankingRenegociar dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'cobranca' ? (
          <BankingCobranca dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'recusado' ? (
          <MotivoRecusa dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'credito_erro' ? (
          <ModalCreditoErro
            id={modal?.id}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}

        {modal?.type === 'sample' ? (
          <ModalSample
            banco={modal?.banco}
            id={modal?.id}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'add-proposal' ? (
          <ModalAddProposal banco={modal?.banco} id={modal?.id} />
        ) : null}
        {modal?.type === 'bureau' ? (
          <BankingMotor
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'credito' ? (
          <BankingNegocios
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'bankmesa' ? (
          <BankingDocumentos
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'parecer' ? <BankingCredito {...modal} /> : null}
        {modal?.type === 'curadoriabanking' ? (
          <CuradoriaBanking
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'curadoriacredito' ? (
          <CuradoriaCredito
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}

        {modal?.type === 'log' ? (
          <ModalLog
            itensErros={modal?.adicionais}
            itensCorretos={modal?.certos}
          />
        ) : null}
        {modal?.type === 'agendarcliente' ? (
          <AgendaProposta dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'recusado' ? (
          <MotivoRecusa dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'observacao' ? (
          <ModalObservacao
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'encerrasol' ? (
          <FinalizaSol
            dados={modal?.dados}
            reload={modal?.reload}
            origem={modal?.origem}
          />
        ) : null}
        {modal?.type === 'profissao_omni' ? (
          <BankingProfissaoOmni {...modal} />
        ) : null}
        {modal?.type === 'confirma_documentos' ? (
          <ConfirmDocumentation {...modal} />
        ) : null}
        {modal?.type === 'formalizabanco' ? (
          <FormalizaBanco dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'upload_file' ? <ModalUploadFile {...modal} /> : null}
        {modal?.type === 'historico_cobranca' ? (
          <HistoricoCobranca dados={modal?.dados} reload={modal?.reload} />
        ) : null}
        {modal?.type === 'importar_cobranca' ? (
          <ImportarCobranca reload={modal?.reload} modo="carteira" />
        ) : null}
        {modal?.type === 'baixa_lote_cobranca' ? (
          <ImportarCobranca reload={modal?.reload} modo="baixa" />
        ) : null}
        {modal?.type === 'billing_forward' ? (
          <BillingForward
            dados={modal?.dados}
            destination={modal?.destination}
            reload={modal?.reload}
          />
        ) : null}
        {modal?.type === 'billing_run_dunning' ? (
          <BillingRunDunning reload={modal?.reload} />
        ) : null}
        {modal?.type === 'billing_cancel_renegotiation' ? (
          <BillingCancelRenegotiation
            dados={modal?.dados}
            reload={modal?.reload}
          />
        ) : null}
      </ThemedComponent>
    </>
  );
}
